var exports = {
  "GY": "tokenUsageSection__R1cdTW",
  "PF": "tokenUsageSectionHeader__uqhvQ9",
  "oC": "tokenUsageSectionTitle__p_ffNs",
  "X$": "tokenUsageSectionTitleBadge__Rj-hfX",
  "xW": "tokenUsageDetails__K4AWQH",
  "el": "tokenUsageDetailsSpacious__xDJnnF",
  "ob": "sessionTokenGrid__5kBqVa",
  "Zj": "tokenUsageDetailMuted__QLf4CL",
  "_4": "tokenUsageDetail__whADQx",
  "EM": "tokenUsageDetailRight__W06K5d",
  "mD": "tokenUsageDivider__m1byCk",
  "MD": "editBudgetLink__ivBVfJ",
};

module.exports = exports;
